import { render, staticRenderFns } from "./InputOTC.vue?vue&type=template&id=4f353ed6&scoped=true"
import script from "./InputOTC.vue?vue&type=script&lang=js"
export * from "./InputOTC.vue?vue&type=script&lang=js"
import style0 from "./InputOTC.vue?vue&type=style&index=0&id=4f353ed6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f353ed6",
  null
  
)

export default component.exports